@if (group) {
  <div [formGroup]="group">
    <mat-form-field>
      <input matInput type="number" placeholder="0.00" formControlName="value" />
      @if (showHint) {
        <mat-hint>{{ group.get('customFieldType')?.value | customFieldType }}</mat-hint>
      }
    </mat-form-field>
  </div>
}
